import Swal from 'sweetalert2';

export const ToastSwal = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    customClass: { popup: 'swal-zindex' },
});
